import {
  Button,
  ButtonType,
  Modal,
  Typography,
  TypographyAlignment,
  TypographySize,
  TypographyWeight,
  TypographyWrap
} from '~/components/core';

interface ConfirmationModalProps {
  header: string;
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
  cancelButtonLabel?: string;
  children?: React.ReactNode;
  confirmButtonLabel?: string;
  confirmDisabled?: boolean;
  confirmLoading?: boolean;
  subtext?: string | React.ReactNode;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  header,
  subtext,
  confirmButtonLabel,
  cancelButtonLabel,
  confirmLoading = false,
  confirmDisabled = false,
  onConfirm,
  onCancel,
  children
}) => (
  <Modal open={open}>
    <div
      className="flex flex-col items-center justify-between gap-6"
      data-testid="confirmation-modal-container"
    >
      <div
        className="flex flex-col justify-center gap-2"
        data-testid="confirmation-modal-header-container"
      >
        <Typography
          alignment={TypographyAlignment.CENTER}
          size={TypographySize.H4}
          weight={TypographyWeight.SEMI_BOLD}
        >
          {header}
        </Typography>
        {subtext && (
          <Typography
            alignment={TypographyAlignment.CENTER}
            wrap={TypographyWrap.PRE_WRAP}
          >
            {subtext}
          </Typography>
        )}
      </div>
      {children}
      <div
        className="flex w-full items-center justify-end gap-2"
        data-testid="confirmation-modal-buttons-container"
      >
        <Button
          label={cancelButtonLabel ?? 'Cancel'}
          onClick={onCancel}
          type={ButtonType.OUTLINED}
        />
        <Button
          disabled={confirmDisabled}
          label={confirmButtonLabel ?? 'Confirm'}
          loading={confirmLoading}
          onClick={onConfirm}
          type={ButtonType.SOLID}
        />
      </div>
    </div>
  </Modal>
);

export default ConfirmationModal;
